import React, { useState, useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { WorkPermit } from "../../../api";
import { useAuth } from "../../../hooks";
import { WorkPermitDetail } from "../../../components/Admin/WorkPermits";
import { LoadingSpinner } from "../../../components/Shared";

const wpController = new WorkPermit();

export function WorkPermitView() {
  const { id }           = useParams();
  const navigate         = useNavigate();
  const { accessToken }  = useAuth();
  const [searchParams]   = useSearchParams();
  const autoOpenLmra     = searchParams.get("action") === "lmra";

  const [permit,  setPermit]  = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await wpController.getWorkPermit(accessToken, id);
        setPermit(data);
      } catch {
        setError("No se encontró el permiso o no tenés acceso.");
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

  const handleClose = () => navigate("/admin/work-permits");

  const handleEdit = () => navigate("/admin/work-permits");

  const handleReload = async () => {
    try {
      const data = await wpController.getWorkPermit(accessToken, id);
      setPermit(data);
    } catch { /* ignorar */ }
  };

  if (loading) return (
    <div style={{ padding: "3rem" }}>
      <LoadingSpinner />
    </div>
  );

  if (error || !permit) return (
    <div style={{ padding: "3rem", color: "#dc2626", textAlign: "center" }}>
      <p>{error || "Permiso no encontrado."}</p>
      <button onClick={handleClose} style={{ marginTop: "1rem", cursor: "pointer" }}>
        ← Volver a Permisos de Trabajo
      </button>
    </div>
  );

  return (
    <div style={{ padding: "1.5rem" }}>
      <WorkPermitDetail
        permit={permit}
        onEdit={handleEdit}
        onClose={handleClose}
        onReload={handleReload}
        autoOpenLmra={autoOpenLmra}
      />
    </div>
  );
}
